import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from 'vue'
import { Icons } from '@/icons/icons'
import { ActionBarButton } from './types/ActionBarComponentTypes'

// PROPS


export default /*#__PURE__*/_defineComponent({
  __name: 'LfCustomContextMenu',
  props: {
  buttons: {
    type: Array as PropType<ActionBarButton[]>,
    required: true
  }
},
  emits: ['execute-action', 'opened'],
  setup(__props, { emit }) {

const props = __props;



// DATA
const kebabIcon = Icons.KEBAB

// EVENTS


const parsedButtons = computed(() => props.buttons.filter((button: ActionBarButton) => !button.hidden))

// METHODS
function onKebabClick() {
  emit('opened')
}

function executeAction(action: string) {
  emit('execute-action', action)
}

return { __sfc: true,props, kebabIcon, emit, parsedButtons, onKebabClick, executeAction }
}

})